import { CombinatorRendererProps, OwnPropsOfControl, rankWith } from '@jsonforms/core';
import { withJsonFormsOneOfProps } from '@jsonforms/react';
import { Select } from '@mantine/core';
import { hasCustomComponent } from '../../utils/testers';
import { MantineOneOfBase } from './MantineOneOfBase';
import { IconRelationOneToMany } from '@tabler/icons-react';

export interface OwnOneOfProps extends OwnPropsOfControl {
  indexOfFittingSchema?: number;
}

export const MantineOneOfSelectRenderer = (props: CombinatorRendererProps) => {
  return (
    <MantineOneOfBase
      Component={Select}
      {...props}
      componentProps={{
        miw: 200,
        maw: 320,
        leftSection: <IconRelationOneToMany />,
      }}
    />
  );
};

export const mantineOneOfSelectControlTester = rankWith(5, hasCustomComponent('oneof-select'));

export default withJsonFormsOneOfProps(MantineOneOfSelectRenderer);
